/**
 * Wrap each rich-text table in a horizontally-scrollable container so wide data
 * tables (e.g. multi-column reference charts) scroll instead of overflowing the
 * layout, while tables that fit simply fill the content column.
 */
(function () {
  function wrapTables() {
    document.querySelectorAll('.rte table').forEach(function (table) {
      var parent = table.parentElement;
      if (parent && parent.classList.contains('rte-table-scroll')) return; // already wrapped
      var wrap = document.createElement('div');
      wrap.className = 'rte-table-scroll';
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapTables);
  } else {
    wrapTables();
  }
})();
